__turbopack_context__.v({
  "bg": "MediaFrame-module__6nztKW__bg",
  "dual": "MediaFrame-module__6nztKW__dual",
  "media": "MediaFrame-module__6nztKW__media",
  "root": "MediaFrame-module__6nztKW__root",
  "sourceContainer": "MediaFrame-module__6nztKW__sourceContainer",
  "sourceContainer2": "MediaFrame-module__6nztKW__sourceContainer2",
  "title": "MediaFrame-module__6nztKW__title",
});
